/**
 * Create HCPController
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('HcpController', ['$scope','$window','Hcp', function($scope, $window, Hcp){
  /**
   * Initial State of Scope
   */
  $scope.hcps     = [];
  $scope.results  = false;

  // SearchForm
  $scope.formData = {
    content_disabled:false,
    scopes:{}
  };


  /**
   * Remote Search for the HCP
   *
   */
  $scope.search = function(p){

    // Form data
    var form = $scope.formData || {};

    // Initial State of HCPs
    $scope.hcps = [];

    // Initial Page Number
    form.page = p || 1

    // Disable search form
    form.content_disabled = true;

    // Injuected resource Hcp will handle the search
    Hcp.get(form, function(response){
      if (response){
        $scope.results  = response;

        // Push the item ito the array of HCPs
        $scope.hcps     = response.data || [];

        // Enable the form
        $scope.formData.content_disabled = false;
      }
    }, function($error){
        _.each($error.data, function(error){
            $.publish('resource.error', error);
        });
    });
  }


  /**
   * Return the HCP to the upper scope, whaever it may be
   *
   * @param  Hcp    hcp
   * @param  string as
   * @return Void
   */
  $scope.pushToParent = function(hcp, as){
    $scope.$parent[as] = hcp;
  }

  /**
   * True if the formData does not contain anything importnat
   *
   * @return {boolean}
   */
  $scope.emptySearch = function(){
    return _.chain($scope.formData)
            .omit(['content_disabled', 'scopes', 'page'])
            .reject(i => _.isEmpty(i))
            .size()
            .value() < 1
  }
}]);
